const WhyUsSection = () => {
  const features = [
    {
      icon: 'ri-award-line',
      title: '10+ Yıl Deneyim',
      description: 'Sektörde 10 yılı aşkın deneyimimizle güvenilir hizmet',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Yüksek Onay Oranı',
      description: 'Profesyonel evrak hazırlığı ile yüksek başarı oranı',
    },
    {
      icon: 'ri-refund-line',
      title: 'İade Garantisi',
      description: 'İade garantili danışmanlık modeli ile güvence',
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Şeffaf Fiyat Politikası',
      description: 'Net ve rekabetçi fiyatlandırma, gizli ücret yok',
    },
  ];

  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-0 items-stretch">
          {/* Left Side - Large Number */}
          <div className="bg-navy-900 flex items-center justify-center p-8 md:p-12 lg:p-14 rounded-t-2xl lg:rounded-l-2xl lg:rounded-tr-none">
            <div className="text-center">
              <div className="font-display text-6xl md:text-8xl lg:text-9xl font-bold text-cream-400 leading-none mb-3 md:mb-4">
                10+
              </div>
              <div className="flex flex-col items-center space-y-1 md:space-y-2">
                <div className="h-1 w-16 md:w-20 bg-cream-400 rounded-full"></div>
                <p className="font-display text-xl md:text-3xl font-semibold text-cream-100 tracking-wider">
                  YIL
                </p>
                <p className="font-display text-lg md:text-2xl font-light text-cream-200">
                  DENEYİM
                </p>
              </div>
            </div>
          </div>

          {/* Right Side - Features */}
          <div className="bg-cream-50 p-6 md:p-10 lg:p-12 rounded-b-2xl lg:rounded-r-2xl lg:rounded-bl-none">
            <div className="mb-6 md:mb-8">
              <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-navy-900 mb-3 md:mb-4">
                Neden Bizi Seçmelisiniz?
              </h2>
              <p className="text-navy-600 text-sm md:text-base">
                İzmir vize danışmanlığı alanında <strong>yüksek onay oranı, iade garantisi</strong> ve <strong>profesyonel evrak takibi</strong> ile öne çıkıyoruz
              </p>
            </div>

            <div className="space-y-3 md:space-y-5">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl md:rounded-2xl p-4 md:p-5 shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
                  style={{
                    animation: `slideInRight 0.6s ease-out ${index * 0.1}s both`,
                  }}
                >
                  <div className="flex items-start space-x-3 md:space-x-4">
                    <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-navy-900 rounded-lg md:rounded-xl flex-shrink-0">
                      <i className={`${feature.icon} text-lg md:text-2xl text-cream-400`}></i>
                    </div>
                    <div>
                      <h3 className="font-display text-base md:text-lg font-bold text-navy-900 mb-1 md:mb-2">
                        {feature.title}
                      </h3>
                      <p className="text-navy-600 leading-relaxed text-xs md:text-sm">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-3 md:gap-5 mt-6 md:mt-10 pt-5 md:pt-7 border-t border-navy-200">
              <div className="text-center">
                <div className="font-display text-2xl md:text-3xl font-bold text-navy-900 mb-1">5000+</div>
                <div className="text-navy-600 text-xs md:text-sm">Başarılı Başvuru</div>
              </div>
              <div className="text-center">
                <div className="font-display text-2xl md:text-3xl font-bold text-navy-900 mb-1">4500+</div>
                <div className="text-navy-600 text-xs md:text-sm">Mutlu Müşteri</div>
              </div>
              <div className="text-center">
                <div className="font-display text-2xl md:text-3xl font-bold text-navy-900 mb-1">25+</div>
                <div className="text-navy-600 text-xs md:text-sm">Ülke</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
      `}</style>
    </section>
  );
};

export default WhyUsSection;